import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable import/no-cycle */
import React, { useEffect, useState } from "react";
import { useScreenWidth } from "Root/profile/components/SubscriptionPageV2/hooks";
import { useHistory } from "react-router-dom";
import { NavBar as CheckoutNav } from "CheckoutComponents";
import { apiGetHowToLPData, apiGetUserData } from "Root/api/apiProfile";
import { Loading } from "../../../components";
import HTLPCarouselBody from "./HTLPCarouselBody/index";
import styles from "./style.module.css";
import HTLPRoutine from "./HTLPRoutine/index";
import HTLPPersonalRD from "./HTLPPersonalRD/index";
import NavBar from "../Navigation/NavBar";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { fetchProfileDataThunk } from "Root/profile/redux/thunkCreators/myProfile/profileThunk";
import H2Font from "../common/H2Font";
const HowToLP = () => {
    const history = useHistory();
    const [lpData, setLpData] = useState(null);
    const [user, setUser] = useState({
        name: "",
    });
    const dispatch = useDispatch();
    const reduxStoreIsEmpty = useSelector((state) => state.checkStore.profile);
    const fetchData = async () => {
        if (reduxStoreIsEmpty) {
            dispatch(fetchProfileDataThunk());
        }
        const response = await apiGetHowToLPData();
        const userResponse = await apiGetUserData();
        setUser(userResponse);
        setLpData(response);
    };
    const isCheckout = window.location.pathname.includes("checkout");
    const userName = isCheckout
        ? user?.name
        : useSelector((state) => state.user?.name);
    const goNext = () => {
        history.push("/checkout/");
    };
    useEffect(() => {
        window.scrollTo(0, 0);
        fetchData();
    }, []);
    const isMobile = useScreenWidth() < 768;
    return (_jsxs(_Fragment, { children: [isCheckout ? (_jsxs(_Fragment, { children: [_jsx(CheckoutNav, { active: -1, cart: null, continue: goNext, view: "howtolp", isBottomHidden: true }), _jsx("div", { style: { height: "80px" } })] })) : (_jsx(NavBar, { userName: userName, showTop: true, userLoggedIn: true })), _jsx("div", { className: styles.howtolp_container, children: _jsxs("div", { className: `${isMobile
                        ? styles.howtolp_content_container_mob
                        : styles.howtolp_content_container}`, children: [_jsx(H2Font, { children: "Deep Dive into Your System" }), lpData ? (_jsxs(_Fragment, { children: [_jsx(HTLPCarouselBody, { items: lpData.items && lpData.items, isCheckout: isCheckout }), _jsx(HTLPRoutine, { workout_routine: lpData.workout_routine, workout_time: lpData.workout_time }), _jsx(HTLPPersonalRD, { assigned_rd: lpData.assigned_rd, thought_starters: lpData.thought_starters, isCheckout: isCheckout })] })) : (_jsx(Loading, {}))] }) })] }));
};
export default HowToLP;
